import React, { useState, useEffect } from "react";
import "../../src/pages/consultation/consultation.css";
import { SwiperSlide } from "swiper/react";
import AOS from "aos";
import { getStudioList } from "../axios";
import SliderPagination from "./common/SliderPagination";

const StudioAtropineSlider = () => {
  const [studioList, setStudioist] = useState([]);

  //getting blogs(news) data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getStudioList();
        if (data) setStudioist(data.reverse().slice(0, 11));
      } catch (error) {
        console.log(error.message);
      }
    };

    fetchData();
  }, []);

  //initializing aos animations
  useEffect(() => {
    AOS.init({
      once: true,
    });
  }, []);

  return (
    <section id="recent_news" class="recent-news">
      <div class="container pb-5">
        <div class="row">
          <div class="text-center col-12 section-title" data-aos="fade-zoom-in">
            <h3 className="main-title">
              <span> استودیو</span> آتروپین
            </h3>
          </div>
        </div>
        <div class="row pb-5">
          <div class="col-12">
            <div class="recent-news-slider" data-aos="fade-up">
              <SliderPagination space={30} slidesPerGroup={1}>
                {studioList?.map((item) => (
                  <SwiperSlide
                    key={item.id}
                    slidesPerView={1}
                    slidesPerGroup={1}
                  >
                    <div class="item">
                      <div class="row align-items-center">
                      <div class="col-md-6 col-12 d-flex flex-column gap-4">
                          <h3>{item.title}</h3>
                          <p>
                            {item.text.length > 200
                              ? item.text.substring(0, 200) + "..."
                              : item.text}
                          </p>
                          <ul class="news-meta">
                            <li>
                              <span class="lnr lnr-user"></span> توسط مدیر
                            </li>
                          </ul>
                          {/* <a
                            target="_blank"
                            href={`/blog/${item.title}`}
                            class="readMore-btn"
                          >
                            <span>بیشتر بخوانید</span>
                          </a> */}
                        </div>
                        {item?.link && item?.link?.length && (
                          <div class="col-md-6 col-12">
                            <div class="h_iframe-aparat_embed_frame">
                              <span
                                style={{ display: "block", paddingTop: "58%" }}
                              ></span>
                              <iframe
                                src={item?.link}
                                allowFullScreen="true"
                                webkitallowfullscreen="true"
                                mozallowfullscreen="true"
                              ></iframe>
                            </div>
                          </div>
                        )}
                        
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </SliderPagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudioAtropineSlider;
